(() => {
  if (window.__preaExternalCustomizerLoader) return;
  window.__preaExternalCustomizerLoader = true;

  const selector = [
    '.amzcustom-open',
    '[class*="amzcustom" i]',
    '[id*="amzcustom" i]',
    '[class*="amazon-customizer" i]',
    '[id*="amazon-customizer" i]'
  ].join(',');
  let loadingPromise = null;

  const cleanup = () => {
    document.removeEventListener('pointerover', onIntent, true);
    document.removeEventListener('pointerdown', onIntent, true);
    document.removeEventListener('focusin', onIntent, true);
  };

  const loadOverlay = () => {
    if (window.__preaExternalCustomizerOverlay) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    const src = window.__preaThemeAssets?.externalCustomizerOverlay;
    if (!src || typeof window.__preaLoadScript !== 'function') return Promise.resolve();

    loadingPromise = window
      .__preaLoadScript(src, 'prea-external-customizer-overlay')
      .then(cleanup)
      .catch(() => {
        loadingPromise = null;
      });

    return loadingPromise;
  };

  function onIntent(event) {
    if (!event.target?.closest?.(selector)) return;
    loadOverlay();
  }

  document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
  document.addEventListener('pointerdown', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent, { capture: true });
})();
